export default __webpack_public_path__ + "static/media/log10~TEHwUkUw.a75bfce1.svg";